export default __webpack_public_path__ + "static/media/close_bet.b13e1908.mp3";